import { Components, Theme } from '@mui/material/styles';
import { ThemeBranding } from '../types';
import type { } from '@mui/x-data-grid/themeAugmentation';

/** Row class that dims a row's text, e.g. for inactive records. */
export const mutedGridRowClassName = 'muted-row';

export const createDataGridTheme = (settings: ThemeBranding): Components<Theme>['MuiDataGrid'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      [`& .${mutedGridRowClassName}`]: { color: theme.palette.text.secondary },
    }),
    columnHeaderTitle: ({ theme }) => ({
      color: `${theme.palette.getContrastText(settings.primaryTableHeaderColor)}`,
    }),
    columnSeparator: ({ theme }) => ({
      color: `${theme.palette.getContrastText(settings.primaryTableHeaderColor)}`,
      '&:hover': {
        color: `${theme.palette.getContrastText(settings.primaryTableHeaderColor)}`,
      },
    }),
    sortIcon: ({ theme }) => ({
      color: `${theme.palette.getContrastText(settings.primaryTableHeaderColor)}`,
    }),
    menuIconButton: ({ theme }) => ({
      color: `${theme.palette.getContrastText(settings.primaryTableHeaderColor)}`,
    }),
  },
});
